/** Who a query points to: colleagues and/or the "Directly To Client" label. */
export interface Recipients {
  userIds: string[];
  toClient: boolean;
}

export const NO_RECIPIENTS: Recipients = { userIds: [], toClient: false };

export const hasRecipients = (r: Recipients) => r.userIds.length > 0 || r.toClient;
